import React from "react";

/**
 * EntitiesStrip — fila de logos de entidades (prueba social).
 * Si no hay entidades, devuelve null.
 */
export function EntitiesStrip({ entities }) {
  if (!entities || entities.length === 0) return null;

  return (
    <section
      className="border-b border-gray-200 bg-white"
      data-testid="landing-entities-section"
    >
      <div className="container-prose py-14">
        <p className="text-center text-xs uppercase tracking-[0.22em] text-brand-coral font-semibold mb-8">
          Confían en JustSapiens Procure
        </p>
        <ul
          className="flex flex-wrap items-center justify-center gap-x-10 gap-y-8"
          data-testid="entities-grid"
        >
          {entities.map((e) => {
            const inner = (
              <div className="bg-white flex items-center justify-center h-12 sm:h-14 px-4">
                {e.logo_b64 ? (
                  <img
                    src={e.logo_b64}
                    alt={e.name}
                    className="max-h-full max-w-[160px] object-contain grayscale opacity-70 hover:grayscale-0 hover:opacity-100 transition-all"
                    loading="lazy"
                  />
                ) : (
                  <span className="text-sm font-serif text-gray-600 italic">{e.name}</span>
                )}
              </div>
            );
            return (
              <li key={e.id} data-testid={`entity-public-${e.id}`}>
                {e.url ? (
                  <a
                    href={e.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    title={e.name}
                    className="inline-block"
                  >
                    {inner}
                  </a>
                ) : (
                  <span title={e.name}>{inner}</span>
                )}
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}
